/**
 * One country table for the whole app.
 *
 * There were three, and they disagreed: KentekenLookup.jsx used `GB`, CarMap.jsx and
 * pocketbase.js used `UK`, pocketbase.js had no `NL` or `BE`, and SearchFilters.jsx kept a
 * fourth hardcoded list of the served set. A cross-market matrix names every country twice --
 * once down the side and once across the top -- so it needs a single source, and the old
 * copies can migrate onto this one when they are next touched.
 */

export const COUNTRY_NAMES = {
  NL: 'Netherlands', DE: 'Germany', IT: 'Italy', FR: 'France', AT: 'Austria', BE: 'Belgium',
  ES: 'Spain', PL: 'Poland', DK: 'Denmark', SE: 'Sweden', FI: 'Finland', PT: 'Portugal',
  CH: 'Switzerland', RO: 'Romania', UK: 'United Kingdom', GB: 'United Kingdom',
  LU: 'Luxembourg', CZ: 'Czechia',
}

/** The markets we actually scrape. Anything else is history in the tracker. */
export const SCRAPED_COUNTRIES = ['NL', 'DE', 'IT', 'FR', 'AT', 'ES', 'PL', 'PT', 'SE', 'DK', 'FI', 'CH', 'RO']

export const countryName = code => COUNTRY_NAMES[String(code || '').toUpperCase()] || code

/** react-world-flags speaks ISO 3166-1 alpha-2; AutoUncle says UK. */
export const toFlagCode = code => (code === 'UK' ? 'GB' : code)
